$(document).ready(function () {
    featuredCollection($('.TabList__Item').first());
    if ($(window).width() > 1007) {
        sliderHorizontal($('.Product__SlideshowNavScroller'));
    }
    tabArcodion();
    showMoreLess();
    featureTextImage($('.FeatureText'));
    brandList();

    // Miniatures produit scroll/flèches
    $('.Product__ThumbnailsArrow').on('click', function () {
        var $scroller = $(this).siblings('.Product__ThumbnailsScroller');
        var direction = $(this).hasClass('Product__ThumbnailsArrow--next') ? 1 : -1;
        var scrollAmount = $scroller.find('.Product__ThumbnailImage').outerWidth(true) * 3;
        $scroller.animate({ scrollLeft: $scroller.scrollLeft() + direction * scrollAmount }, 300);
    });

    $('.Product__ThumbnailImage').on('click', function (e) {
        e.preventDefault();
        $('.Product__ThumbnailImage').removeClass('is-selected');
        $(this).addClass('is-selected');
        var mediaId = $(this).data('media-id');
        var $mainMedia = $('#Media' + mediaId);
        $('.Product__SlideItem').removeClass('is-selected');
        $mainMedia.addClass('is-selected');
        // Optionnel: scroll vers la photo principale
        $('html, body').animate({ scrollTop: $('.Product__Gallery').offset().top - 80 }, 300);
    });
})

function featuredCollection(elm) {
    let id = $(elm).attr('aria-controls');
    let parent = $(`#${id}`);
    let $productSlider = $(parent).find('.product-slider');
    let $progressBar = $(parent).find('.progress');
    let $progressBarLabel = $(parent).find('.slider__label');

    let width = $(document).width();
    let calc;

    let numItem = $productSlider.find('.product-silder_item');
    calc = (1.2 / numItem.length) * 100;
    $progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc);

    $progressBarLabel.text(calc + '% completed');


    $productSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (width > 1140) {
            calc = ((nextSlide + 0.2 + 0.2) / (slick.slideCount - 5.2)) * 100;
        } else if (width > 768) {
            calc = ((nextSlide + 0.2) / (slick.slideCount - 3.2)) * 100;
        } else if (width > 640) {
            calc = ((nextSlide + 0.2) / (slick.slideCount - 2.2)) * 100;
        } else {
            calc = ((nextSlide + 0.2) / (slick.slideCount - 1.2)) * 100;
        }

        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc);

        $progressBarLabel.text(calc + '% completed');
    });

    $productSlider.slick({
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: $('.SectionHeader_collections .slick-prev'),
        nextArrow: $('.SectionHeader_collections .slick-next'),
        slidesToShow: 5.2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3.2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}

function sliderHorizontal(elm) {
    
    elm.slick({
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: true,
        prevArrow: '<button type="button" class="slick-prev"><svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9201 8.0499L10.4001 1.52989C9.6301 0.759893 8.3701 0.759893 7.6001 1.52989L1.08008 8.0499" stroke="#1F1F1F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next"><svg width="18" height="9" viewBox="0 0 18 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.9201 0.949951L10.4001 7.47C9.6301 8.24 8.3701 8.24 7.6001 7.47L1.08008 0.949951" stroke="#1F1F1F" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
    })
}

$(document).on('click', '.TabList__Item', function () {
    let id = $(this).attr('aria-controls');
    let parent = $(`#${id}`);
    let $productSlider = $(parent).find('.product-slider');
    if (!$productSlider.hasClass('slick-initialized')) {
        featuredCollection(this);
    }
});

function brandList() {
    let width = $(document).width();
    if (width > 640) {
        $('.brand-list_inner').slick('unslick');
    } else {
        $('.brand-list_inner').slick({
            dots: false,
            infinite: true,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: true
        });
    }
}

function tabArcodion() {
    $('.ProductMeta__Tab a:first-child').addClass('active');
    $('.ProductMeta__Tab--content').hide();
    $('.ProductMeta__Tab--content:first').show();

    $('.ProductMeta__Tab--links').click(function () {
        $('.ProductMeta__Tab--links').removeClass('active');
        $(this).addClass('active');
        $('.ProductMeta__Tab--content').hide();

        let activeTab = $(this).attr('href');
        $(activeTab).fadeIn();
        return false;
    });
}

function showMoreLess() {
    let showChar = 304;
    let ellipsisesText = " ";
    let moreText = "+More";
    let lessText = "-Less";
    $(".ProductForm__Description .Rte").each(function () {
        let content = $(this).html().replace(/(<p)/igm, '<span').replace(/<\/p>/igm, '</span>');
        if (content.length > showChar) {
            var first = content.substring(0, showChar);
            var last = content.substring(showChar, content.length);
            var html = first + '<span class="more-ellipses">' + ellipsisesText + '&nbsp;</span><span class="more-content"><div>' + last + '</div>&nbsp;&nbsp;<a href="" class="more-link">' + moreText + '</a></span>';
            $(this).html(html);
        }
    })

    $(".more-link").click(function () {
        if ($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moreText);
            console.log($(this).html(moreText));
        } else {
            $(this).addClass("less");
            $(this).html(lessText);
            console.log($(this).html(lessText));
        }

        $(this).parent().prev().toggle();
        $(this).prev().toggleClass('active');
        return false;
    })
}

function featureTextImage(elm) {
    elm.slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        infinite: false
    });
}

// Handle image scroll arrows on mobile
$(document).on('click', '[data-scroll-prev]', function() {
    const wrapper = $(this).closest('[data-image-scroll]');
    const scrollAmount = 300;
    wrapper.animate({
        scrollLeft: wrapper.scrollLeft() - scrollAmount
    }, 300);
});

$(document).on('click', '[data-scroll-next]', function() {
    const wrapper = $(this).closest('[data-image-scroll]');
    const scrollAmount = 300;
    wrapper.animate({
        scrollLeft: wrapper.scrollLeft() + scrollAmount
    }, 300);
});